export default "__VITE_ASSET__Cv3X77Xb__"